var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaEw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "hidden",
    viewBox: "0 0 132 74",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 12,
    width: 132,
    height: 74
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36 -12)",
    clipPath: "url(#clip0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 -1.0799 -48.935 152.85)",
    d: "m133.42 129.1c-49.469-7.495-65.021-39.35-28.107-58.088 7.495-3.7476 13.116-3.1854 6.183 0.7496-6.183 3.3728-14.053 12.742-14.053 16.677 0 4.8719 4.8724 13.867 8.4324 15.178 1.499 0.75 2.81 0.375 2.81-0.562 0-1.124 3.561-1.874 8.058-1.874s8.619-0.375 9.181-0.937c0.563-0.5618-0.562-8.057-2.436-16.489-1.873-8.4321-3.56-15.927-3.56-16.677 0-1.3117 17.239-5.4341 18.363-4.3098 0.375 0.3748 1.5 7.3078 2.436 15.365 3.186 25.484 0.375 23.048 25.109 23.048 13.117 0 21.549 0.75 21.549 1.874s-14.241 1.874-38.788 1.874c-34.852 0.187-38.6 0.375-35.227 2.811 13.679 10.493 54.153 10.868 74.202 0.749l6.746-3.373 0.188-16.302c0.187-8.9942 0.749-16.677 1.124-17.239 2.061-1.8738 16.114 9.1816 19.113 14.99 13.304 25.671-32.792 49.843-81.323 42.535z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 -1.0799 -48.935 152.85)",
    d: "m151.22 94.252c-0.562-0.9369-1.499-8.4321-2.249-16.864l-1.312-15.553h7.496 7.682l0.562 8.9943c0.563 7.3078 1.125 8.8068 4.31 8.8068 2.998 0 3.935-1.499 4.31-7.8699 0.562-8.9943 0.375-8.8069 10.306-5.9962l7.12 1.8738-0.562 13.491-0.562 13.491-7.87 0.5622c-7.308 0.5621-7.87 0.1873-8.432-4.6845-0.75-7.3079-7.87-7.4952-8.62 0-0.562 4.1223-1.499 5.0592-5.996 5.0592-2.998 0-5.809-0.5621-6.183-1.3116z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaEw);
export default __webpack_public_path__ + "static/media/TAEw.6d5c14bde69fd21b25a813dcad4321ef.svg";
export { ForwardRef as ReactComponent };